<script setup lang="ts">
import { reactive } from "vue";
import Container, {
  ContainerType,
  EffectTriggerTiming
} from "../Container.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Container },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    containerType?: ContainerType;
    supportCopyText?: boolean;
    effectTriggerTiming?: EffectTriggerTiming;
    color?: string;
    dur?: number;
    direction?: "up" | "down" | "left" | "right";
  }>(),
  {
    containerType: "shrink",
    supportCopyText: true,
    effectTriggerTiming: "mouseMove",
    color: "#3cefff",
    dur: 200,
    direction: "up"
  }
);

// const emits = defineEmits<{
//   (event: "click"): void;
// }>();

const style = reactive<Record<string, string>>({});

const start = () => {
  switch (props.direction) {
    case "left":
      style.transformOrigin = "center left";
      style.transform = "scaleX(0)";
      break;
    case "right":
      style.transformOrigin = "center right";
      style.transform = "scaleX(0)";
      break;
    case "down":
      style.transformOrigin = "center bottom";
      style.transform = "scaleY(0)";
      break;
    case "up":
      style.transformOrigin = "center top";
      style.transform = "scaleY(0)";
      break;
  }
};
const end = () => {
  switch (props.direction) {
    case "left":
      style.transformOrigin = "center right";
      style.transform = "scaleX(1)";
      break;
    case "right":
      style.transformOrigin = "center left";
      style.transform = "scaleX(1)";
      break;
    case "down":
      style.transformOrigin = "center top";
      style.transform = "scaleY(1)";
      break;
    case "up":
      style.transformOrigin = "center bottom";
      style.transform = "scaleY(1)";
      break;
  }
};

defineExpose({});
</script>

<template>
  <Container
    :type="props.containerType"
    :supportCopyText="props.supportCopyText"
    :effectTriggerTiming="props.effectTriggerTiming"
    @start="start"
    @end="end"
    style="overflow: hidden"
  >
    <div
      class="slide-before"
      :style="{
        backgroundColor: props.color,
        transition: `transform ${props.dur}ms ease-in-out`,
        ...style
      }"
    ></div>
    <div class="slide">
      <slot></slot>
    </div>
  </Container>
</template>

<style scoped>
.slide-before {
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.slide {
  position: relative;
  z-index: 1;
  cursor: pointer;
}
</style>
